var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4434_2505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2806 14.0306L12.5306 20.7806C12.461 20.8504 12.3782 20.9057 12.2872 20.9434C12.1961 20.9812 12.0985 21.0006 12 21.0006C11.9014 21.0006 11.8038 20.9812 11.7128 20.9434C11.6217 20.9057 11.539 20.8504 11.4694 20.7806L4.71936 14.0306C4.61435 13.9257 4.54282 13.792 4.51383 13.6465C4.48485 13.5009 4.4997 13.35 4.55651 13.2129C4.61333 13.0758 4.70955 12.9586 4.83299 12.8762C4.95644 12.7938 5.10156 12.7499 5.24998 12.75H11.25V3.75C11.25 3.55109 11.329 3.36032 11.4697 3.21967C11.6103 3.07902 11.8011 3 12 3C12.1989 3 12.3897 3.07902 12.5303 3.21967C12.671 3.36032 12.75 3.55109 12.75 3.75V12.75H18.75C18.8984 12.7499 19.0435 12.7938 19.167 12.8762C19.2904 12.9586 19.3866 13.0758 19.4434 13.2129C19.5003 13.35 19.5151 13.5009 19.4861 13.6465C19.4571 13.792 19.3856 13.9257 19.2806 14.0306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4434_2505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowIcon);
export default __webpack_public_path__ + "static/media/DownArrow_icon.6e133fb0116a1e9edd4dd273fd3b661e.svg";
export { ForwardRef as ReactComponent };